import { ApiUrlPrepare } from "@lib/helpers/ApiHelper";
import { API } from "@lib/services/http";
import { ApiParams, PaginationType } from "@lib/types/Api";
import { AppConfig } from "@lib/types/AppConfig";
import { BillingConfig } from "@lib/types/BillingConfig";

// App Config
export const apiGetAppConfig = async (id: string) => {
  const url = `/payment-hub-app-config/${id}`;
  return API.get<AppConfig>(url);
};

export const apiAddAppConfig = async (data: Partial<AppConfig>) => {
  return API.post<AppConfig>(`/payment-hub-app-config`, data);
};

export const apiDeleteAppConfig = async (data: AppConfig) => {
  return API.delete<null>(`/payment-hub-app-config/${data.id}`);
};

export const apiUpdateAppConfig = async (data: Partial<AppConfig>) => {
  const { id, ...rest } = data as AppConfig;
  return API.patch<AppConfig>(`/payment-hub-app-config/${id}`, rest);
};

export const apiGetAppConfigs = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/payment-hub-app-config` });
  return API.get<PaginationType<AppConfig>>(url);
};

//
// Billing Config
export const apiGetBillingConfig = async (id: string) => {
  const url = `/billing-config/${id}`;
  return API.get<BillingConfig>(url);
};

export const apiAddBillingConfig = async (data: BillingConfig) => {
  return API.post<BillingConfig>(`/billing-config`, data);
};

export const apiDeleteBillingConfig = async (data: BillingConfig) => {
  return API.delete<null>(`/billing-config/${data.id}`);
};

export const apiUpdateBillingConfig = async (data: Partial<BillingConfig>) => {
  const { id, ...rest } = data as BillingConfig;
  return API.patch<BillingConfig>(`/billing-config/${id}`, rest);
};

export const apiGetBillingConfigs = async <T extends ApiParams>(params: T) => {
  const url = ApiUrlPrepare({ params, url: `/billing-config` });
  return API.get<PaginationType<BillingConfig>>(url);
};
